export default "__VITE_ASSET__qlBbfx9j__"